import { Component, Input } from '@angular/core';
import { App, PopoverController, Platform } from 'ionic-angular';
import { NavController, NavParams } from 'ionic-angular';
import { ActionsProvider } from '../../providers/actions/actions';

/**
 * Generated class for the ContactsListComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({ 
    selector: 'contacts-list',                  
    templateUrl: 'contacts-list.html'
})               
export class ContactsListComponent {

    @Input('list') list: any[] = [];
    @Input('callOnTouch') callOnTouch = false;
  
                
    constructor(private popoverCtrl: PopoverController,
        public navCtrl: NavController,
        public actions: ActionsProvider,
        public platform: Platform,
        public app: App
    ) {   
    } 

    /**
   * Metodo che presenta il popover per i contatti
   */
    presentPopover(myEvent, c) {
        let popover = this.popoverCtrl.create('PopoverPage', { contact: c });
        popover.present({
            ev: myEvent,
        });
        
    }

    openContact(elem) {
        this.navCtrl.push('ProfilePage', { contact: elem }, {animate:false} )
    } 


}



// WEBPACK FOOTER //
// ./src/components/contacts-list/contacts-list.ts